import React from 'react';
import {Link} from 'react-router-dom';

export default class CustomAppBarPublic extends React.Component {


    render() {
        return (
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <Link className="navbar-brand" to="/">MonEntretien<span style={{color: "#007bff"}}>PRO</span></Link>
            </nav>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/utils/CustomAppBarPublic.js